<div class="cg-button-group">
  <button
    *ngIf="showPrevious"
    data-test="prev-btn"
    [disabled]="submitting"
    (click)="previous.emit()"
    cignaButton="secondary"
  >
    {{ previousButtonLabel }}
  </button>
  <button
    data-test="next-btn"
    [disabled]="!nextEnabled || submitting"
    (click)="next.emit()"
    cignaButton="primary"
  >
    {{ nextButtonLabel }}
  </button>
  <button
    *ngIf="showCancel"
    data-test="cancel-link"
    (click)="cancel()"
    cignaButton="link"
  >
    Cancel
  </button>
  <div
    *ngIf="submitting"
    style="display: inline-block; vertical-align: bottom;"
    class="cg-spinner cg-margin-left-md"
  ></div>
</div>
